"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameSounds = void 0;
var GameSounds;
(function (GameSounds) {
    GameSounds["CREDITS"] = "resources/audio/cash_register.mp3";
    GameSounds["PIXELS"] = "resources/audio/pixels.mp3";
    GameSounds["RECEIVE_MSG"] = "resources/audio/receive_msg.mp3";
    GameSounds["SENT_MSG"] = "resources/audio/sent_msg.mp3";
})(GameSounds = exports.GameSounds || (exports.GameSounds = {}));
